// extracted by mini-css-extract-plugin
export var renderedContent = "TitleComponent-module--renderedContent--d9d19";
export var titleStyling = "TitleComponent-module--titleStyling--d99aa";